import CancelButton from 'app/components/buttons/CancelButton'
import ConfirmationDialog from 'app/components/ConfirmationDialog'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import UpdatePlanButton from './UpdatePlanButton'
import { lte, lt } from 'ramda'

function CreateNotificationOverdraftFreePlanDialog({
  isOpen,
  onClose,
  notesAvailable,
  totalCreditRequired,
  toChangePlan,
  handleUpdatePlanClick,
}) {
  const { formatMessage } = useIntl()
  const isNotesNotAvailable = lte(notesAvailable, 0)
  const isSubscribersOverNotesAvailable = lt(
    notesAvailable,
    totalCreditRequired,
  )

  const handleBodyMessage = () => {
    if (isNotesNotAvailable) {
      return (
        <FormattedMessage
          id="createNotification.dialog.freeTrial.notesAvailable.overLimit.detail"
          values={{
            totalCreditRequired,
            notesAvailable,
            b: (text) => <b>{text}</b>,
            m1: (text) => <div className="mt-24">{text}</div>,
          }}
        />
      )
    }

    if (isSubscribersOverNotesAvailable) {
      return (
        <FormattedMessage
          id="createNotification.dialog.freeTrial.overSubscriber.detail"
          values={{
            totalCreditRequired,
            notesAvailable,
            b: (text) => <b>{text}</b>,
            m1: (text) => <div className="mt-24">{text}</div>,
          }}
        />
      )
    }
  }

  return (
    <ConfirmationDialog
      open={isOpen}
      title={formatMessage({
        id: 'createNotification.dialog.overdraft.dialog.title',
      })}
      body={handleBodyMessage()}
      CancelButton={<CancelButton onClick={onClose} />}
      ConfirmButton={
        <UpdatePlanButton
          toChangePlan={toChangePlan}
          handleUpdatePlanClick={handleUpdatePlanClick}
        />
      }
    />
  )
}

CreateNotificationOverdraftFreePlanDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  notesAvailable: PropTypes.number,
  totalCreditRequired: PropTypes.number,
  toChangePlan: PropTypes.string.isRequired,
  handleUpdatePlanClick: PropTypes.func,
}

export default CreateNotificationOverdraftFreePlanDialog
